import { Component, OnInit, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.css']
})
@Injectable()
export class TitleComponent implements OnInit {
  bankNameShort: any='Mogaveera Bank';
  bankNameShort1: any='Mogaveera Bank';

public TITTLE =this.bankNameShort+" Online Banking";
public TITTLE1 =this.bankNameShort1;
public TITTLE2 =this.bankNameShort;
public TITTLE3 =this.bankNameShort1;
// public TITTLE4 ="www.maheshbankpune.in";
public TITTLE5 =this.bankNameShort;
public TITTLE6 =this.bankNameShort1;
public TITTLE7 =this.bankNameShort+" Online Banking";
public TITTLE8 = this.bankNameShort1;
public TITTLE9 =this.bankNameShort1;
public TITTLE10 =this.bankNameShort;
public TITTLE11 =this.bankNameShort+" Internet Banking";
  constructor( private http: HttpClient) {

    // this.getJSON().subscribe(data => {
    //   this.bankNameShort = data.bankNameShort;
    //   this.bankNameShort1 = data.bankNameShort1;
    //   console.log('values, bankNameShort1 '+ this.bankNameShort);
    //  });    
    //  setTimeout(() => {  this.TITTLE=this.bankNameShort+" Online ";
    //  console.log('title :'+this.TITTLE); }, 1000);
     
   
     //'title' is printed first taht means this line is executed first and later 'values' line

   }
//  public getJSON(): Observable<any> {
//     return this.http.get('assets/SampleUrl.json'); 
//   }
  ngOnInit() {
  }



//   public TITTLE ="Mahesh Bank Online Banking";
//   public TITTLE1 ="Mahesh Sahakari Bank Ltd";
//   public TITTLE2 ="Mahesh Bank";
//   public TITTLE3 ="Mahesh Sahakari Bank Ltd";
//  // public TITTLE4 ="www.maheshbankpune.in";
//   public TITTLE5 ="Mahesh Bank";
//   public TITTLE6 ="Mahesh Sahakari Bank Ltd";
//   public TITTLE7 ="Mahesh Bank Online Banking";
//   public TITTLE8 ="Mahesh Sahakari Bank Ltd";
//   public TITTLE9 ="Mahesh Sahakari Bank Ltd";
//   public TITTLE10 ="Mahesh bank";
//   public TITTLE11 ="Mahesh Bank Internet Banking";


// public TITTLE =this.bankNameShort+" Online Banking";
// public TITTLE1 =this.bankNameShort1+" Ltd";
// public TITTLE2 =this.bankNameShort;
// public TITTLE3 =this.bankNameShort1+" Ltd";
// // public TITTLE4 ="www.maheshbankpune.in";
// public TITTLE5 =this.bankNameShort;
// public TITTLE6 =this.bankNameShort1+" Ltd";
// public TITTLE7 =this.bankNameShort+" Online Banking";
// public TITTLE8 = this.bankNameShort1+" Ltd";
// public TITTLE9 =this.bankNameShort1+" Ltd";
// public TITTLE10 =this.bankNameShort;
// public TITTLE11 =this.bankNameShort+" Internet Banking";





}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/title/title.component.ts